import { produce } from 'immer';

const produceSchedule = (amount, fillValue) => {
  const arr = new Array(amount);

  for (let i = 0; i < amount; i++) {
    if (typeof fillValue === 'function') {
      arr[i] = fillValue();
    } else {
      arr[i] = fillValue;
    }
  }

  return arr;
};

export const produceInitState = () => ({
  totalSelected: 0,
  schedule: produceSchedule(7, () => produceSchedule(24, 0)),
  everyday: produceSchedule(24, 0),
});

// If the same hour in everyday is selected, then set the selected flag in the everyday array
// TODO: Figure out a better var name other than dayInner. It looks gross
function determineEverydaySelection(draft, hour) {
  if (draft.schedule.every(dayInner => dayInner[hour] === 1)) {
    draft.everyday[hour] = 1;
  }
}

const scheduleReducer = produce((draft, action) => {
  switch (action.type) {
    case 'addHour': {
      const { day, hour } = action.payload;

      draft.schedule[day][hour] = 1;
      draft.totalSelected++;

      determineEverydaySelection(draft, hour);

      return;
    }
    case 'addHourEveryday': {
      const { hour } = action.payload;

      draft.schedule.forEach((day) => {
        day[hour] = 1;
        draft.totalSelected++;
      });
      draft.everyday[hour] = 1;

      return;
    }
    case 'removeHour': {
      const { day, hour } = action.payload;

      draft.schedule[day][hour] = 0;
      draft.totalSelected--;
      draft.everyday[hour] = 0;

      return;
    }
    case 'removeHourEveryday': {
      const { hour } = action.payload;

      draft.schedule.forEach((day) => {
        day[hour] = 0;
        draft.totalSelected--;
      });

      draft.everyday[hour] = 0;

      return;
    }
    case 'reset': {
      return produceInitState();
    }
    default:
  }
});

export default scheduleReducer;
